var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-dialer-tabs", class: _vm.states },
    [
      _vm.type === "inline"
        ? _vm._l(_vm.tabsWithKeys, function (tab) {
            return _c(
              "div",
              {
                key: tab.key,
                staticClass: "tab",
                class: { "is-active": tab.key === _vm.activeTabId },
                on: {
                  click: function ($event) {
                    return _vm.onTabChange(tab)
                  },
                },
              },
              [
                _c("span", { staticClass: "label" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.getTabTitle(tab)) + "\n      "
                  ),
                ]),
              ]
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "compact"
        ? [
            _c(
              "div",
              {
                staticClass: "toggle-button",
                class: { "is-open": _vm.isOpen },
                on: { click: _vm.onOpenClick },
              },
              [
                _c("or-icon", { attrs: { icon: "expand_more" } }),
                _vm._v(" "),
                _c("span", { staticClass: "label" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.activeTabLabel) + "\n      "
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isOpen
              ? _vm._l(_vm.options, function (option) {
                  return _c(
                    "div",
                    {
                      key: option.key,
                      staticClass: "tab-option",
                      on: {
                        click: function ($event) {
                          return _vm.onTabChange(option)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getTabTitle(option)) +
                            "\n        "
                        ),
                      ]),
                    ]
                  )
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }